import { useState, useEffect, useCallback } from 'react';
import { API } from '../services';

type endpoints =
  | 'calculator/maximummortgagebyincome'
  | 'employerstatement/aanvullendevoorzieningen'
  | 'employerstatement/werkgeversverklaring';

export const useApi = <IResponse, IBody = void>(endpoint: endpoints, body?: IBody) => {
  const [data, setData] = useState<IResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(false);

    try {
      const fetch = body
        ? API.post<IResponse, IBody>(endpoint, body)
        : API.get<IResponse>(endpoint);
      const response = await fetch;
      //console.log(response);
      setData(response);
    } catch (err) {
      setError(true);
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [endpoint, body]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, fetchData };
};
